module.exports = __webpack_public_path__ + "static/media/edit_icon.e9316ca3.svg";